/**
 * 功能列表服务
 */
"use strict";
angular.module("burstNewsRuleServiceMoudle", [
	"brcheckModule",  //查看详情
    "braddruleModule",  //添加编辑规则
    "breditruleModule",  //编辑规则
    "brhelpModule",  //帮助
]).
factory("burstNewsRuleService", ["$modal","$q", function($modal, $q) {
    return {
        brcheck: function(id,type) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./planningResource/commandMonitor/publicOpinionMgrZj/burstNewsRule/service/check/check_tpl.html",
                windowClass: "m-checkbox",
                backdrop: false,
                resolve: {
                    item: function() {
                        return {
                            id: id,
                            type: type
                        };
                    },
                },
                controller: "brcheckCtrl"
            });
            modalInstance.result.then(function(data) {
                deffer.resolve(data);
            }, function() {

            });
            return deffer.promise;
        },
        help: function(id) {
            var modalInstance = $modal.open({
                templateUrl: "./planningResource/commandMonitor/publicOpinionMgrZj/burstNewsRule/service/help/help_tpl.html",
                windowClass: "m-helpbox",
                backdrop: false,
                resolve: {
                    item: function() {
                        return {
                            id: id,
                        };
                    },
                   
                },
                controller: "brhelpCtrl"
            });
            modalInstance.result.then(function(result) {
            });
        },
        braddrule: function(type) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./planningResource/commandMonitor/publicOpinionMgrZj/burstNewsRule/service/addrule/addrule_tpl.html",
                windowClass: "m-addrulebox",
                backdrop: false,
                resolve: {
                    item:{
                        type:type
                    }
                },
                controller: "braddruleCtrl"
            });
            modalInstance.result.then(function(data) {
                deffer.resolve(data);
            }, function() {

            });
            return deffer.promise;
        },
        breditrule: function(id,type) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./planningResource/commandMonitor/publicOpinionMgrZj/burstNewsRule/service/addrule/addrule_tpl.html",
                windowClass: "m-addrulebox",
                backdrop: false,
                resolve: {
                    item: function() {
                        return {
                            id: id,
                            type: type
                        };
                    },
                },
                controller: "breditruleCtrl"
            });
            modalInstance.result.then(function(data) {
                deffer.resolve(data);
            }, function() {

            });
            return deffer.promise;
        }
    };
}]);